const VERSION = '3.1.2';
export function getVersionString() {
    return VERSION;
}
